import React, { useEffect, useState } from 'react';
import store, { loanActions } from '@apply/adminStore';
import { LoanApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';
import { RefreshEvents } from '../../../common/SharedEvents';
import DataGrid, { Column } from 'devextreme-react/data-grid';

export const RentalHoldbackReleasesGrid = ({ propertyId }) => {
    const { dispatch } = store;
    const loanApi = new LoanApi.LoanApi(applicationInsights);
    const refreshEvents = new RefreshEvents();

    const [releases, set_releases] = useState([]);
    const [isEditable, set_isEditable] = useState(false);

    const loadData = async () => {
        if (!propertyId) {
            return;
        }

        const response = await loanApi.getRentalHoldbackReleaseGrid(propertyId);
        if (response.statusCode !== 200) {
            return;
        }
        set_releases(response.result.releases);
        set_isEditable(response.result.isEditable);
    };

    useEffect(() => {
        refreshEvents.addRefreshListener(_afterRefresh);
        return () => {
            refreshEvents.removeRefreshListener(_afterRefresh);
        };
    }, []);

    useEffect(() => {
        // Do we need to await if no code follows?
        async function propertyIdChanged() {
            await loadData();
        }

        propertyIdChanged();
    }, [propertyId]);

    const _afterRefresh = async () => {
        await loadData();
    };

    const editHoldbackRelease = (event, releaseId) => {
        event.preventDefault();
        event.stopPropagation();

        dispatch(
            loanActions.setReleaseHoldbackModal({
                holdbackReleaseModal: { isOpen: true, propertyId, releaseId },
            })
        );
    };

    const actionCellRender = (e) => {
        if (isEditable) {
            return (
                <button
                    id={'action_' + e.data.id}
                    className='gridButton'
                    title='Edit Rental Holdback rRlease'
                    onClick={(event) => editHoldbackRelease(event, e.data.id)}
                >
                    Edit
                </button>
            );
        } else {
            return '';
        }
    };

    const onPaymentNumberRender = (e) => {
        return e.rowIndex + 1;
    };

    if (!propertyId || !releases || releases.length === 0) {
        return '';
    }

    return (
        <DataGrid
            dataSource={releases}
            showBorders={true}
            showRowLines={false}
            showColumnHeaders={true}
            rowAlternationEnabled={true}
            columnMinWidth={50}
            columnAutoWidth={false}
            sorting={false}
        >
            <Column
                cellRender={onPaymentNumberRender}
                caption='#'
                width={20}
            />
            <Column
                dataField='releaseDate'
                caption='Date'
                dataType='date'
                width={100}
            />
            <Column
                dataField='amount'
                caption='Amount'
                dataType='number'
                format='currency'
                width={100}
                alignment='left'
            />
            <Column
                dataField='remainingHoldback'
                caption='Remaining'
                dataType='number'
                format='currency'
                width={100}
                alignment='left'
            />
            <Column
                dataField='notes'
                caption='Notes'
            />
            <Column
                alignment='center'
                cellRender={actionCellRender}
                width={50}
                allowSorting={false}
                allowResizing={false}
            />
        </DataGrid>
    );
};
